import * as React from 'react'
import { SVGProps } from 'react'
const SvgSelectCaret: React.FC<React.SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.or/g/2000/svg" viewBox="0 0 9 12" fill="none" {...props}>
    <path d="m7.908 7.716-3.5 3-3.5-3M.908 3.716l3.5-3 3.5 3" stroke="currentColor" />
  </svg>
)
export default SvgSelectCaret
